/**
 * Fecha y hora de las pantallas de automatización, en formato local (KAN-443).
 *
 * `toLocaleString()` y `toLocaleTimeString()` sin locale siguen el idioma del
 * navegador: en un Chrome en inglés el 1 de octubre sale "10/1/2026" y la hora
 * con AM/PM. Acá el locale es explícito (es-AR, como `graphqlToDate` de
 * `common/utils`) y la hora va en 24 horas desde 00 (`h23`): con `h24`, que es
 * lo que usa `graphqlToDateTime`, la medianoche sale "24:05".
 *
 * Se muestra en la zona horaria del navegador, igual que antes.
 *
 * Es provisorio. Cuando la parte del generador de KAN-443 pase
 * `graphqlToDateTime` a `h23`:
 * - `localDateTime` se reemplaza por `graphqlToDateTime` si no hacen falta los
 *   segundos; si hacen falta, se le pide al generador una variante con
 *   segundos y se usa esa;
 * - para `localTime` se le pide al generador un helper de solo hora;
 * - y este módulo se borra, para no tener dos formateadores de fecha y hora en
 *   paralelo.
 */

const HORA: Intl.DateTimeFormatOptions = {
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hourCycle: "h23",
};

/** "14:35:12" */
export const localTime = (value: Date | string): string =>
  new Date(value).toLocaleTimeString("es-AR", HORA);

/** "01/10/2026, 14:35:12" */
export const localDateTime = (value: Date | string): string =>
  new Date(value).toLocaleString("es-AR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    ...HORA,
  });
